import { useContext } from 'react';
import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';
import { Button, ButtonGroup, Group, Menu, Text } from '@mantine/core';

import { PlusCircleIconSm, ChevronDownIconXs, EditIconSm } from '@chownow/pantry/icons';
import ActionMenu from './ActionMenu';

interface MultiRowActionsProps {
  isModifierSelected?: boolean;
}

export default function MultiRowActions({ isModifierSelected }: MultiRowActionsProps) {
  const { checkedItems, setDefaultMods } = useContext(MenuMappingContext);

  if (!checkedItems?.control) return null;

  return (
    <Menu position="bottom-start">
      <ButtonGroup>
        <Menu.Target>
          <Button variant="ghost" size="sm" leftSection={<EditIconSm />}>
            <Group gap="xs2">
              <Text variant="caption-xs" truncate="end">
                Edit
              </Text>
              <ChevronDownIconXs />
            </Group>
          </Button>
        </Menu.Target>
        <ActionMenu rowKey={checkedItems?.control} isModifierSelected={isModifierSelected} />
        {!isModifierSelected && (
          <Button
            variant="ghost"
            size="sm"
            leftSection={<PlusCircleIconSm />}
            onClick={() => setDefaultMods({ rowKey: checkedItems?.control, value: [] })}
          >
            <Group gap="xs2">
              <Text variant="caption-xs" truncate="end">
                Add POS Modifier
              </Text>
            </Group>
          </Button>
        )}
      </ButtonGroup>
    </Menu>
  );
}
